"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMessage = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./helper-text.types");
exports.StyledMessage = theme_1.styled.div `
  ${theme_1.typography.regular14}
  line-height: 20px;
  color: ${({ status, theme }) => {
    switch (status) {
        case 'error':
            return theme.colors.text.error;
        case 'success':
            return theme.colors.text.success;
        default:
            return theme.colors.text.secondary;
    }
}};

  ${({ messagePosition, noMargin }) => messagePosition === 'down'
    ? (0, theme_1.css) `
          margin-top: ${noMargin ? 0 : '8px'};
        `
    : (0, theme_1.css) `
          margin-bottom: ${noMargin ? 0 : '8px'};
        `}
`;
